import styled from "styled-components";

const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 1.25rem;
  width: 1.2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
`

const ArrowButton = styled.div`
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.1rem;
  height: 0.8rem;
  font-size: 0.6rem;
  border-radius: 2px;
  color: ${({ theme }) => theme.font.label};
  transition: color 0.15s ease, background-color 0.15s ease;

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.font.highlight};
    background-color: ${({ theme }) => theme.table.hover};
  }

  &:active {
    background-color: ${({ theme }) => theme.table.active};
    color: ${({ theme }) => theme.font.color};
  }
`

function UpDownArrows({ onIncrement, onDecrement }) {
  return (
    <ButtonWrapper>
      <ArrowButton onMouseDown={e => e.preventDefault()} onClick={onIncrement}>▲</ArrowButton>
      <ArrowButton onMouseDown={e => e.preventDefault()} onClick={onDecrement}>▼</ArrowButton>
    </ButtonWrapper>
  );
}

export default UpDownArrows;
